import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { delay } from 'rxjs/operators';
import { ModuleContentSidebarService } from './module-content-sidebar.service';
import { SidebarSize } from './app-frame.types';

@UntilDestroy()
@Component({
  selector: 'hk-app-frame',
  template: `
    <div class="flex h-full w-full flex-col gap-1 border-0 border-hk_gray-100 bg-hk_gray-100 md:border-[24px]">
      <div class="flex h-fit min-h-12 flex-none items-center justify-start gap-2 bg-white p-2 empty:hidden">
        <ng-content select="[hkAppToolbar]"></ng-content>
      </div>
      <div class="relative flex flex-1">
        <div class="absolute left-0 top-0 flex h-full w-full flex-1 flex-col">
          <div class="flex h-full w-full flex-1">
            <div class="flex h-full w-full flex-1 flex-col overflow-auto rounded-sm bg-white p-6 empty:hidden">
              <ng-content select="[hkAppContent]"></ng-content>
              <ng-content></ng-content>
            </div>
            <div class="flex h-full w-full flex-1 flex-col overflow-auto rounded-sm bg-white empty:hidden">
              <ng-content select="[hkAppContentRaw]"></ng-content>
            </div>
            <div *ngIf="contentLeftOrRight" class="flex h-full w-full flex-1 flex-col gap-4 overflow-auto bg-hk_gray-100 xl:flex-row">
              <div #contentLeft class="flex flex-1 flex-col gap-4 xl:basis-2/3">
                <ng-content select="[hkAppContentLeft]"></ng-content>
              </div>
              <div #contentRight class="flex flex-1 flex-col gap-4 xl:basis-1/3">
                <ng-content select="[hkAppContentRight]"></ng-content>
              </div>
            </div>
            <div
              *ngIf="sidebarEnabled && sidebarOpen"
              class="absolute right-0 top-0 flex flex-none flex-col rounded-sm border-hk_gray-100 bg-white md:static md:border-l-[12px]"
              [ngClass]="sizeAvailables[sidebarWidth]"
            >
              <hk-layout-container [scrollable]="true">
                <ng-content select="[hkAppSidebar]"></ng-content>
              </hk-layout-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hk-centered-mat-spinner data-testid="appFrame.loadingSpinner" *ngIf="showSpinner"></hk-centered-mat-spinner>
  `,
  host: { class: 'flex flex-1 flex-col' },
})
export class AppFrameComponent implements AfterViewInit {
  // https://tailwindcss.com/docs/content-configuration#dynamic-class-names
  public sizeAvailables: Record<SidebarSize, string> = {
    '250px': 'basis-[250px] w-[250px] max-w-[250px]',
    '300px': 'basis-[300px] w-[300px] max-w-[300px]',
    '350px': 'basis-[350px] w-[350px] max-w-[350px]',
    '400px': 'basis-[400px] w-[400px] max-w-[400px]',
  };
  @Input() public sidebarWidth: SidebarSize = '250px';
  @Input() public showSpinner = false;
  @Input() public sidebarEnabled = false;

  @Input() sidebarOpen = false;
  contentLeftOrRight = true;

  @ViewChild('contentLeft') contentLeft?: ElementRef<HTMLDivElement>;
  @ViewChild('contentRight') contentRight?: ElementRef<HTMLDivElement>;

  constructor(
    private moduleContentSidebarService: ModuleContentSidebarService,
    private _cdr: ChangeDetectorRef,
  ) {}

  public ngAfterViewInit() {
    this.contentLeftOrRight = !!(this.contentLeft?.nativeElement?.children?.length || this.contentRight?.nativeElement?.children?.length);

    this.moduleContentSidebarService.onChangedSidebarStatus.pipe(untilDestroyed(this), delay(0)).subscribe({
      next: (open) => {
        if (this.sidebarEnabled) {
          this.sidebarOpen = open;
          this._cdr.detectChanges();
        }
      },
    });
    this._cdr.detectChanges();
  }
}
